import { queryKeys } from '@query/keys'
import { PaginatedQueryResult, usePaginatedQuery } from '@query/usePaginatedQuery'

import { useSessionLanguage } from '@context/SessionSettingsContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { DealDto } from '@model/DealDto'
import { FilterQueryProps } from '@model/FilterFields'

interface Props {
  search: SearchResponseProps
}

interface SearchResponseProps {
  search: FilterQueryProps
  debouncedSearchTerm: string | null
}

export const IB_INCOME_REPORTS_SEARCH_TERM = 'ca_search_TextSearch'

export const useIBIncomeFetch = (props: Props): { query: PaginatedQueryResult<DealDto> } => {
  const { search } = props

  const locale = useSessionLanguage()
  const apiClient = useApiClient(ClientApiClient)

  const searchKey = {
    ...search.search,
    ca_search_TextSearch: search.debouncedSearchTerm,
    locale,
  }

  const query = usePaginatedQuery({
    queryKey: queryKeys.ib.income(searchKey, locale),
    queryFn: (pageQuery) =>
      apiClient.getIntroducingBrokerIncome({
        ...pageQuery,
        search: { ...search.search, [IB_INCOME_REPORTS_SEARCH_TERM]: search.debouncedSearchTerm },
        sort: pageQuery?.sort,
        sortOrder: pageQuery?.sortOrder,
        caller: 'ca',
        languageId: locale,
      }),
  })

  return { query }
}
